<template>
  <div
    v-if="userRol.id==3 || userRol.id==2"
    class="float-right mr-5"
  >
    <b-button
      :to="{ name: 'editar-usuario', params: { id: personaFk } }"
      variant="primary"
    >
      Editar Perfil
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { rolesActions } from '@core/mixins/account-data/roles'

export default {
  components: { BButton },
  mixins: [rolesActions],
  props: {
    personaFk: {
      type: String,
      required: true,
    },
  },
}
</script>
